var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wallet-settings" } },
    [
      _vm.addBalanceModal
        ? _c("WalletAddBalance", {
            attrs: { "is-admin": _vm.isAdmin },
            on: {
              "add-balance": _vm.addBalanceWhatsapp,
              close: function ($event) {
                _vm.addBalanceModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creditCardNeededModal
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardNeededModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAutoRebalancePromo
        ? _c("AutoRebalancePromoModal", {
            on: {
              activate: _vm.handleAutoRebalancePromoActivate,
              close: _vm.handleAutoRebalancePromoClose,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "balance-card" },
        [
          _c("div", { staticClass: "balance-left" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "balance-text" }, [
              _c("span", { staticClass: "balance-label" }, [
                _vm._v(_vm._s(_vm.$t("billing.availableBalance"))),
              ]),
              _vm._v(" "),
              _vm.wallet.whatsapp
                ? _c("span", { staticClass: "balance-amount" }, [
                    _vm._v(
                      _vm._s(_vm.formatPrice(_vm.wallet.whatsapp.amount)) +
                        " " +
                        _vm._s(_vm.$t("billing.currencyTL"))
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: true, icon: "add" },
              on: { click: _vm.openAddWhatsappBalanceModal },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("billing.addBalance")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "underline-tabs" }, [
        _c(
          "div",
          {
            staticClass: "u-tab",
            class: { active: _vm.activeMainTab === "transactions" },
            on: {
              click: function ($event) {
                _vm.activeMainTab = "transactions"
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("receipt_long"),
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("billing.walletTransactions")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "u-tab",
            class: { active: _vm.activeMainTab === "auto-rebalance" },
            on: {
              click: function ($event) {
                _vm.activeMainTab = "auto-rebalance"
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("autorenew"),
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("billing.autoReload")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.activeMainTab === "transactions"
        ? _c("div", { key: _vm.$i18n.locale, staticClass: "tx-panel" }, [
            _c("div", { staticClass: "filter-bar" }, [
              _c(
                "div",
                { staticClass: "product-pills" },
                _vm._l(_vm.productOptions, function (p) {
                  return _c(
                    "div",
                    {
                      key: p.value,
                      staticClass: "pill",
                      class: { active: _vm.activeTab === p.value },
                      on: {
                        click: function ($event) {
                          return _vm.onProductChange(p.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(p.label))]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-toolbar" }, [
              _c(
                "div",
                { staticClass: "toolbar-left" },
                [
                  _c("FilterChip", {
                    attrs: {
                      type: "date",
                      value: _vm.dateFilterValue,
                      "filter-name": _vm.$t("message.date") || "Tarih",
                      icon: "date_range",
                      clearable: true,
                      "operator-selectable": true,
                      operator: _vm.dateOperator,
                    },
                    on: {
                      change: _vm.onDateFilterChange,
                      "operator-change": _vm.onDateOperatorChange,
                      clear: _vm.onDateFilterClear,
                    },
                  }),
                  _vm._v(" "),
                  _vm.typeOptions.length > 0
                    ? _c("FilterChip", {
                        attrs: {
                          type: "select",
                          value: _vm.selectedTypes,
                          options: _vm.typeOptions,
                          "filter-name":
                            _vm.$t("billing.transactionTypes") || "İşlem Tipi",
                          multiple: true,
                          "enable-search": true,
                          icon: "category",
                          clearable: true,
                        },
                        on: {
                          change: _vm.onTypesFilterChange,
                          clear: _vm.onTypesFilterClear,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTab === "whatsapp-business-api"
                    ? _c("FilterChip", {
                        attrs: {
                          type: "select",
                          value: _vm.selectedChannelIds,
                          options: _vm.channelFilterOptions,
                          "filter-name": _vm.$t("message.channel") || "Kanal",
                          multiple: true,
                          "enable-search": true,
                          icon: "campaign",
                          clearable: true,
                        },
                        on: {
                          change: _vm.onChannelFilterChange,
                          clear: _vm.onChannelFilterClear,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTab === "ai-usage" && _vm.refOptions.length > 0
                    ? _c("FilterChip", {
                        attrs: {
                          type: "select",
                          value: _vm.selectedRefs,
                          options: _vm.refOptions,
                          "filter-name": _vm.$t("message.resource") || "Kaynak",
                          multiple: true,
                          "enable-search": true,
                          icon: "psychology",
                          clearable: true,
                        },
                        on: {
                          change: _vm.onRefsChange,
                          clear: _vm.onRefsClear,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "toolbar-right" }, [
                _c("span", { staticClass: "pg-info" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.filters.perPage * (_vm.filters.page - 1) + 1) +
                      "–" +
                      _vm._s(
                        Math.min(
                          _vm.filters.perPage * _vm.filters.page,
                          _vm.totalActivity
                        )
                      ) +
                      "\n                    / " +
                      _vm._s(_vm.totalActivity) +
                      " " +
                      _vm._s(_vm.$t("message.records")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pg-controls" },
                  [
                    _c("SupsisButton", {
                      attrs: {
                        ghost: true,
                        small: true,
                        square: true,
                        disabled: _vm.filters.page <= 1,
                        icon: "chevron_left",
                      },
                      on: { click: _vm.backwardPage },
                    }),
                    _vm._v(" "),
                    _c("a-input-number", {
                      staticClass: "pg-input",
                      attrs: { min: 1, max: _vm.totalPages },
                      on: { pressEnter: _vm.jumpToPage, blur: _vm.jumpToPage },
                      model: {
                        value: _vm.currentPageInput,
                        callback: function ($$v) {
                          _vm.currentPageInput = $$v
                        },
                        expression: "currentPageInput",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pg-of" }, [
                      _vm._v("/ " + _vm._s(_vm.totalPages)),
                    ]),
                    _vm._v(" "),
                    _c("SupsisButton", {
                      attrs: {
                        ghost: true,
                        small: true,
                        square: true,
                        disabled: _vm.filters.page >= _vm.totalPages,
                        icon: "chevron_right",
                      },
                      on: { click: _vm.forwardPage },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-area" },
              [
                _c("NewSupsisTable", {
                  key: _vm.activeTab,
                  attrs: {
                    columns: _vm.tableColumns,
                    data: _vm.activities,
                    "show-column-add": true,
                    resizable: true,
                    "sortable-columns": true,
                    "local-storage-key": "wallet-table-" + _vm.activeTab,
                    "row-key": "_id",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell-createdAt",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "cell-date" }, [
                              _vm._v(_vm._s(_vm.formatDate(row.createdAt))),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell-type",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.formatType(row.type, row)) +
                                "\n                "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell-aiResource",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "ai-resource" }, [
                              _vm._v(_vm._s(_vm.getAIUsageResource(row))),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell-phoneNumber",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(_vm.getPhoneNumber(row)))]
                        },
                      },
                      {
                        key: "cell-country",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(_vm.$_.get(row, "payload.country", "-"))
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell-fromNumber",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$_.get(row, "payload.from_number", "-")
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell-toNumber",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(_vm.$_.get(row, "payload.to_number", "-"))
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell-direction",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm.$_.get(row, "payload.direction") === "inbound"
                              ? _c("span", { staticClass: "dir-badge in" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("call_received")]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.$t("message.inbound") || "Gelen")
                                  ),
                                ])
                              : _vm.$_.get(row, "payload.direction") ===
                                "outbound"
                              ? _c("span", { staticClass: "dir-badge out" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("call_made")]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.outbound") || "Giden"
                                    )
                                  ),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                      {
                        key: "cell-aiModel",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "model-chip" }, [
                              _vm._v(
                                _vm._s(_vm.$_.get(row, "payload.model", "-"))
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell-aiProvider",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.type === "ai-rag-rerank"
                              ? _c("span", [_vm._v("Voyage AI")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration.provider_name",
                                        _vm.$_.get(row, "payload.provider", "-")
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "cell-aiDetails",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "ai-detail-wrap" },
                              [
                                row.type === "ai-rag-rerank"
                                  ? [
                                      _c(
                                        "a-tag",
                                        { attrs: { color: "purple" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "billing.walletAiRerankTag"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.$_.get(row, "payload.inputTokens") > 0
                                        ? _c("span", { staticClass: "tok" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatTokenCount(
                                                  _vm.$_.get(
                                                    row,
                                                    "payload.inputTokens"
                                                  )
                                                )
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "billing.walletAiTokenSuffix"
                                                  )
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  : [
                                      _vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration.num_search_results"
                                      ) > 0
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "orange" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "billing.walletAiWebSearchResults",
                                                    {
                                                      n: _vm.$_.get(
                                                        row,
                                                        "payload.openrouterGeneration.num_search_results"
                                                      ),
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration.num_media_prompt"
                                      ) > 0
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "purple" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "billing.walletAiMediaCount",
                                                    {
                                                      n: _vm.$_.get(
                                                        row,
                                                        "payload.openrouterGeneration.num_media_prompt"
                                                      ),
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration.num_input_audio_prompt"
                                      ) > 0
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "cyan" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "billing.walletAiAudioCount",
                                                    {
                                                      n: _vm.$_.get(
                                                        row,
                                                        "payload.openrouterGeneration.num_input_audio_prompt"
                                                      ),
                                                    }
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration.router"
                                      )
                                        ? _c(
                                            "a-tag",
                                            { attrs: { color: "geekblue" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$_.get(
                                                    row,
                                                    "payload.openrouterGeneration.router"
                                                  ) === "openrouter/auto"
                                                    ? _vm.$t(
                                                        "billing.walletAiAutoRouter"
                                                      )
                                                    : _vm.$_.get(
                                                        row,
                                                        "payload.openrouterGeneration.router"
                                                      )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$_.get(
                                        row,
                                        "payload.openrouterGeneration"
                                      )
                                        ? _c("span", [_vm._v("-")])
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell-before",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("MoneyFormatter", {
                              attrs: { price: row.before.toFixed(4) },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell-after",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("MoneyFormatter", {
                              attrs: { price: row.after.toFixed(4) },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell-amount",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("MoneyFormatter", {
                              attrs: { price: row.amount.toFixed(4) },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3646156532
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.activeMainTab === "auto-rebalance"
        ? _c("div", { staticClass: "ar-panel" }, [
            _c("div", { staticClass: "ar-alert" }, [
              _c("span", { staticClass: "material-icons ar-alert-icon" }, [
                _vm._v("info"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ar-alert-body" }, [
                _c("div", { staticClass: "ar-alert-title" }, [
                  _vm._v(_vm._s(_vm.$t("billing.importantInfo"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ar-points" }, [
                  _c("div", { staticClass: "ar-point" }, [
                    _c("span", [_vm._v("⚠️")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.walletImportantPoint1"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ar-point" }, [
                    _c("span", [_vm._v("⏰")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.walletImportantPoint2"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ar-point" }, [
                    _c("span", [_vm._v("🔔")]),
                    _c(
                      "span",
                      [
                        _vm._v(
                          _vm._s(_vm.$t("billing.walletImportantPoint3Before"))
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass: "ar-link",
                            attrs: { to: "/settings/notifications" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("billing.notificationSettings"))
                            ),
                          ]
                        ),
                        _vm._v(
                          _vm._s(_vm.$t("billing.walletImportantPoint3After"))
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ar-point" }, [
                    _c("span", [_vm._v("📋")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.walletImportantPoint4"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ar-point" }, [
                    _c("span", [_vm._v("∞")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.walletImportantPoint5"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ar-card" }, [
              _c("div", { staticClass: "ar-card-head" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("billing.autoBalanceReload")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("billing.autoBalanceReloadDesc"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ar-rows" }, [
                _c("div", { staticClass: "ar-row" }, [
                  _c("div", { staticClass: "ar-lbl" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("billing.autoReloadToggle"))),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.autoReloadToggleDesc"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ar-ctrl" },
                    [
                      _c("a-switch", {
                        on: { change: _vm.onAutoRebalanceEnabledChange },
                        model: {
                          value: _vm.autoRebalanceSettings.enabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.autoRebalanceSettings, "enabled", $$v)
                          },
                          expression: "autoRebalanceSettings.enabled",
                        },
                      }),
                      _vm._v(" "),
                      _vm.autoRebalanceSettings.disabledDueToFailure
                        ? _c("span", { staticClass: "ar-fail" }, [
                            _vm._v(
                              _vm._s(_vm.$t("billing.disabledDueToFailure"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-row" }, [
                      _c("div", { staticClass: "ar-lbl" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("billing.thresholdValue"))),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("billing.thresholdValueDesc"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ar-ctrl" },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "150px" },
                            attrs: { min: 0, max: 5000, step: 1 },
                            on: { change: _vm.onSettingsChange },
                            model: {
                              value: _vm.autoRebalanceSettings.threshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoRebalanceSettings,
                                  "threshold",
                                  $$v
                                )
                              },
                              expression: "autoRebalanceSettings.threshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-row" }, [
                      _c("div", { staticClass: "ar-lbl" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("billing.reloadMode"))),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("billing.reloadModeDesc"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ar-ctrl ar-ctrl-col" },
                        [
                          _c(
                            "a-radio-group",
                            {
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value: _vm.autoRebalanceSettings.mode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings,
                                    "mode",
                                    $$v
                                  )
                                },
                                expression: "autoRebalanceSettings.mode",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: "add" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("billing.addFixedAmount"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-radio",
                                { attrs: { value: "fixedBalance" } },
                                [_vm._v(_vm._s(_vm.$t("billing.fixBalance")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ar-mode-hint" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm.autoRebalanceSettings.mode === "add"
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("billing.modeAddDesc"))),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.modeFixedDesc"))
                                  ),
                                ]),
                          ]),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-row" }, [
                      _c("div", { staticClass: "ar-lbl" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.autoRebalanceSettings.mode === "add"
                                ? _vm.$t("billing.amountToAdd")
                                : _vm.$t("billing.targetBalance")
                            )
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.autoRebalanceSettings.mode === "add"
                                ? _vm.$t("billing.amountToAddDesc")
                                : _vm.$t("billing.targetBalanceDesc")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ar-ctrl" },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              min:
                                _vm.autoRebalanceSettings.mode ===
                                "fixedBalance"
                                  ? _vm.autoRebalanceSettings.threshold + 1
                                  : 1,
                              max: 10000,
                              step: 10,
                            },
                            on: { change: _vm.onSettingsChange },
                            model: {
                              value: _vm.autoRebalanceSettings.upTo,
                              callback: function ($$v) {
                                _vm.$set(_vm.autoRebalanceSettings, "upTo", $$v)
                              },
                              expression: "autoRebalanceSettings.upTo",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-row" }, [
                      _c("div", { staticClass: "ar-lbl" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("billing.panelNotifications"))),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.panelNotificationsDesc"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ar-ctrl ar-ctrl-col" },
                        [
                          _c(
                            "a-checkbox",
                            {
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value:
                                  _vm.autoRebalanceSettings.settings
                                    .notifyOnRecharge,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings.settings,
                                    "notifyOnRecharge",
                                    $$v
                                  )
                                },
                                expression:
                                  "autoRebalanceSettings.settings.notifyOnRecharge",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("billing.notifyOnRecharge")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-checkbox",
                            {
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value:
                                  _vm.autoRebalanceSettings.settings
                                    .notifyOnFailure,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings.settings,
                                    "notifyOnFailure",
                                    $$v
                                  )
                                },
                                expression:
                                  "autoRebalanceSettings.settings.notifyOnFailure",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("billing.notifyOnFailure")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-checkbox",
                            {
                              on: { change: _vm.onSettingsChange },
                              model: {
                                value:
                                  _vm.autoRebalanceSettings.settings
                                    .notifyOnDisabled,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.autoRebalanceSettings.settings,
                                    "notifyOnDisabled",
                                    $$v
                                  )
                                },
                                expression:
                                  "autoRebalanceSettings.settings.notifyOnDisabled",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("billing.notifyOnDisabled")))]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-row" }, [
                      _c("div", { staticClass: "ar-lbl" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("billing.emailNotifications"))),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("billing.emailNotificationsDesc"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ar-ctrl ar-ctrl-col" },
                        [
                          _c("a-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              mode: "tags",
                              placeholder: _vm.$t("billing.emailPlaceholder"),
                              tokenSeparators: [",", ";", " "],
                            },
                            on: { change: _vm.onSettingsChange },
                            model: {
                              value:
                                _vm.autoRebalanceSettings.settings
                                  .emailRecipients,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoRebalanceSettings.settings,
                                  "emailRecipients",
                                  $$v
                                )
                              },
                              expression:
                                "autoRebalanceSettings.settings.emailRecipients",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ar-email-hint" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(_vm._s(_vm.$t("billing.emailHint"))),
                          ]),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoRebalanceSettings.enabled
                  ? _c("div", { staticClass: "ar-status" }, [
                      _c("div", { staticClass: "ar-status-row" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("billing.lastTrigger"))),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.autoRebalanceSettings.lastTriggeredAt
                                ? _vm.formatDate(
                                    _vm.autoRebalanceSettings.lastTriggeredAt
                                  )
                                : _vm.$t("billing.neverTriggered")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.autoRebalanceSettings.failedAttempts > 0
                        ? _c("div", { staticClass: "ar-status-row" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("billing.failedAttempt"))),
                            ]),
                            _c("span", { staticClass: "ar-fail" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.autoRebalanceSettings.failedAttempts
                                ) +
                                  "/" +
                                  _vm._s(
                                    _vm.autoRebalanceSettings.maxFailedAttempts
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ar-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: true, disabled: _vm.savingSettings },
                        on: { click: _vm.saveAutoRebalanceSettings },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.savingSettings
                              ? "..."
                              : _vm.$t("billing.saveSettings")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "balance-icon" }, [
      _c("span", { staticClass: "material-icons" }, [
        _vm._v("account_balance_wallet"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }